/** Scroll distance from the chapter start before the toolbar may hide. */
export const TOOLBAR_ARM_SCROLL_PX = 112;
/** Downward travel, after the arm threshold, that hides the toolbar. */
export const TOOLBAR_HIDE_DELTA_PX = 56;
/** Upward travel that brings the toolbar back. */
export const TOOLBAR_SHOW_DELTA_PX = 14;

export type ToolbarScrollState = {
  visible: boolean;
  pendingDown: number;
  pendingUp: number;
};

export const INITIAL_TOOLBAR_SCROLL_STATE: ToolbarScrollState = {
  visible: true,
  pendingDown: 0,
  pendingUp: 0,
};

export function reduceToolbarVisibility(
  state: ToolbarScrollState,
  {
    scrollTop,
    delta,
    pinned,
  }: {
    scrollTop: number;
    delta: number;
    pinned: boolean;
  },
): ToolbarScrollState {
  if (scrollTop < TOOLBAR_ARM_SCROLL_PX) {
    return INITIAL_TOOLBAR_SCROLL_STATE;
  }

  if (pinned) {
    return { ...state, pendingDown: 0, pendingUp: 0 };
  }

  if (delta > 0) {
    const pendingDown = state.pendingDown + delta;
    if (pendingDown >= TOOLBAR_HIDE_DELTA_PX) {
      return { visible: false, pendingDown: 0, pendingUp: 0 };
    }
    return { ...state, pendingDown, pendingUp: 0 };
  }

  if (delta < 0) {
    const pendingUp = state.pendingUp + -delta;
    if (pendingUp >= TOOLBAR_SHOW_DELTA_PX) {
      return { visible: true, pendingDown: 0, pendingUp: 0 };
    }
    return { ...state, pendingUp, pendingDown: 0 };
  }

  return state;
}
